import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import schoolReducer from './slices/schoolSlice';
import studentReducer from './slices/studentSlice';
import teacherReducer from './slices/teacherSlice';
import attendanceReducer from './slices/attendanceSlice';
import academicReducer from './slices/academicSlice';
import assignmentReducer from './slices/assignmentSlice';
import quizReducer from './slices/quizSlice';
import assessmentReducer from './slices/assessmentSlice';
import examReducer from './slices/examSlice';
import resultReducer from './slices/resultSlice';
import payrollReducer from './slices/payrollSlice';
import financeReducer from './slices/financeSlice';
import libraryReducer from './slices/librarySlice';
import transportReducer from './slices/transportSlice';
import hostelReducer from './slices/hostelSlice';
import notificationReducer from './slices/notificationSlice';
import disciplineReducer from './slices/disciplineSlice';
import aiReducer from './slices/aiSlice';
import uiReducer from './slices/uiSlice';
import teacherLatenessReducer from './slices/teacherLatenessSlice';
import homeworkReducer from './slices/homeworkSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    school: schoolReducer,
    students: studentReducer,
    teachers: teacherReducer,
    attendance: attendanceReducer,
    academic: academicReducer,
    assignments: assignmentReducer,
    quizzes: quizReducer,
    assessments: assessmentReducer,
    exams: examReducer,
    results: resultReducer,
    payroll: payrollReducer,
    finance: financeReducer,
    library: libraryReducer,
    transport: transportReducer,
    hostel: hostelReducer,
    notifications: notificationReducer,
    discipline: disciplineReducer,
    ai: aiReducer,
    ui: uiReducer,
    teacherLateness: teacherLatenessReducer,
    homework: homeworkReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
